import { Component, OnInit ,Inject} from '@angular/core';
import {LabourService} from '../../service/labour.service'
import { SharedService } from 'app/modules/common/services/shared-service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
    selector: 'app-vacation-add',
    templateUrl: './vacation-add.component.html',
    styleUrls: ['./vacation-add.component.scss'],
    standalone: false
})
export class VacationAddComponent implements OnInit {
  isSunday:boolean=false;
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<VacationAddComponent>,
    public labourService :LabourService,
    private sharedService: SharedService
    
  ) {

    this.labourService.fechaForm.get("Fecha").valueChanges.subscribe(x => {
      this.isSunday=isWeekend(this.labourService.fechaForm.get('Fecha').value)
      if(this.isSunday)
      {
        this.labourService.fechaForm.controls['Fecha'].setErrors({'hasError': true});
      }
   })

   }

  ngOnInit(): void {
  }

  onSubmit()
  {
    this.pathValues();
    if(this.labourService.fechaForm.valid)
    {
      this.labourService.addFetcha(this.labourService.fechaForm.value).subscribe(res=>{
        this.labourService.fechaForm.reset();
        this.dialogRef.close();
      }, err => {
        console.error(err);
      })
    }
  }

  onClose()
  {
    this.labourService.fechaForm.reset();
    this.dialogRef.close();
  }

  pathValues()
  {
    this.labourService.fechaForm.patchValue({
      Poblacion: this.data.poblacion,
      Level:this.data.level,
      Comunidad:this.data.comunidad,
    })
  }

}

function isWeekend(string) {
  var date = new Date(string);
  return date.getDay()  === 0;
}